import { Form, Formik } from "formik";
import * as Yup from "yup";
import Input from "../../../../components/input";
import Button from "../../../../components/button";
import { useState } from "react";
import { TrashOutlined } from "../../../../components/icons/trash-outlined";
import { EditOutlined } from "../../../../components/icons/edit-outlined";
import { CheckOutlined } from "../../../../components/icons/check-outlined";
import {
  SummaryGoal,
  WeeklySummaryResponse,
} from "../../../../redux/features/weekly-summary-slice";
import SummaryPropertyDiscussDialog from "../summary-property-discuss-dialog";

interface Props {
  summary: WeeklySummaryResponse | null;
  goals: SummaryGoal[];
  setGoals: (values: SummaryGoal[]) => void;
  onRefresh: () => void;
}

export default function GoalForm(props: Props) {
  const { summary, goals, setGoals, onRefresh } = props;

  const [selectedGoal, setSelectedGoal] = useState<SummaryGoal | null>(null);
  const [editId, setEditId] = useState<string | null>(null); 
  const [editValues, setEditValues] = useState<SummaryGoal | null>(null); 

  return (
    <>
      <div className="flex flex-col space-y-4">
        {goals.map((e: SummaryGoal) => {
          const isEditing = editId === e.goal;
          return (
          <div
            key={e.goal}
            className="flex flex-col items-start p-4 bg-background-default border border-divider space-y-4 rounded-lg"
          >
            <Input
              type="text"
              inputType="textarea"
              rows={3}
              value={isEditing ? editValues?.goal : e.goal}
              readonly={!isEditing}
              onChange={(event) => {
                if (editValues !== null) {
                  setEditValues({ ...editValues, goal: event.target.value });
                }
              }}
              errorText={
                isEditing && editValues
                  ? editValues.goal === ""
                    ? "This field is required"
                    : undefined
                  : undefined
              }
              exWrapClassName="w-full"
            />
            <div className="w-full flex items-center justify-between space-x-2">
              {summary &&
                summary.goals.findIndex((g) => g.goal === e.goal) !== -1 && (
                  <Button
                    variant="outlined"
                    label={`Discusses (${e.discuss.length})`}
                    onClick={() => setSelectedGoal(e)}
                    exClassName="w-fit border-divider"
                  />
                )}
              <div className="flex flex-1 items-center justify-end space-x-2">
                <div
                  className="p-2 rounded cursor-pointer hover:bg-gray-200"
                  onClick={() => {
                    if (isEditing) {
                      if (editValues && editValues.goal !== "") {
                        const editIndex = goals.findIndex(
                          (e1) => e.goal === e1.goal
                        );
                        if (editIndex !== -1) {
                          const tmp = [...goals];
                          tmp[editIndex] = {
                            ...tmp[editIndex],
                            goal: editValues.goal,
                          };
                          setGoals(tmp);
                          setEditValues(null);
                          setEditId(null);
                        }
                      }
                    } else {
                      // Enter edit mode
                      setEditId(e.goal);
                      setEditValues(e);
                    }
                  }}
                >
                  {isEditing ? (
                    <CheckOutlined className="h-4 w-4 text-success-main" />
                  ) : (
                    <EditOutlined className="h-4 w-4" />
                  )}
                </div>
                <div
                  className="p-2 rounded cursor-pointer hover:bg-gray-200"
                  onClick={() =>
                    setGoals(goals.filter((goal) => goal.goal !== e.goal))
                  }
                >
                  <TrashOutlined className="h-4 w-4 text-error-main" />
                </div>
              </div>
            </div>
          </div>
          );
        })}
        <Formik
          initialValues={{ goal: "" }}
          validationSchema={Yup.object().shape({
            goal: Yup.string().required("This field is required"),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(false);
            setGoals([...goals, { goal: values.goal, discuss: [] }]);
            resetForm();
          }}
        >
          {({ values, errors, handleChange, handleSubmit }) => (
            <Form
              noValidate
              autoComplete="off"
              onSubmit={handleSubmit}
              className="flex flex-col items-start space-x-2 space-y-4 border border-divider p-4 rounded-lg"
            >
              <Input
                type="text"
                inputType="textarea"
                rows={1}
                id="goal"
                placeholder="Add goal..."
                value={values.goal}
                onChange={handleChange}
                exWrapClassName="w-full"
              />
              <Button
                type="submit"
                label="Add"
                exClassName="w-fit self-end"
                disabled={
                  Array.isArray(errors) ||
                  Object.values(errors).toString() != ""
                }
              />
            </Form>
          )}
        </Formik>
      </div>
      {summary && (
        <SummaryPropertyDiscussDialog
          summaryId={summary.id}
          type="goal"
          property={selectedGoal}
          setProperty={setSelectedGoal}
          onSubmitted={onRefresh}
        />
      )}
    </>
  );
}
